import { AxiosResponse } from 'axios';
import { useSelector } from 'react-redux';
import { selectAuthToken } from 'selectors';
import { useMutation } from '@tanstack/react-query';
import {
  initializeSubscriptionRealm,
  InitializeSubscriptionRealmFailureResponse,
  InitializeSubscriptionRealmPayload,
  InitializeSubscriptionRealmSuccessResponse,
} from 'RealmModule/services/initializeSubscriptionRealmApi';
import { useNotification } from 'hooks/useNotification';
import { extractApiErrorMessage } from 'utils/extractApiErrorMessage';

export const useInitializeSubscriptionRealm = () => {
  const token = useSelector(selectAuthToken);
  const { showSuccess, showError } = useNotification();

  const mutation = useMutation<
    AxiosResponse<InitializeSubscriptionRealmSuccessResponse>,
    AxiosResponse<InitializeSubscriptionRealmFailureResponse>,
    InitializeSubscriptionRealmPayload
  >({
    mutationFn: async (params) => {
      if (!token) {
        throw new Error('No auth token available');
      }
      return initializeSubscriptionRealm({ params, token });
    },
    onSuccess: (data) => {
      // ✅ FIX: Replace alert() with toast notification
      showSuccess('Initialize realm successful!');
    },
    onError: (error) => {
      // ✅ FIX: Replace alert() with toast notification
      showError(`Initialize realm failed! ${extractApiErrorMessage(error)}`);
    },
  });
  return {
    initializeSubscriptionRealm: mutation.mutate,
    isInitializingSubscriptionRealm: mutation.isPending,
  };
};
